import {ValidationConditionConfig} from "../@types";
import {ValidationCondition} from "../../../modules/validations/@const";


export default class Condition {

    public type     : ValidationCondition
    public value    : any

    constructor(info:ValidationConditionConfig) {

        this.type    = info.type;
        this.value   = info.value


    }


    toJSON() {
        return {
            type      : this.type,
            value     : this.value,
        }
    }

}